<template>
    <div>
        フッターだよ
    </div>
</template>

<script>
export default {
    name: 'PageFooter'
}
</script>



// WEBPACK FOOTER //
// src/components/PageFooter.vue